import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})


export class Config {
 kundenId:string =  '8';
 dataBaseUrl:string = "https://dev2.maereo.de/backend/api";
}
